import React, { ReactElement } from 'react';
import { Box, Theme, SxProps, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { getCredentialPartials, getProduct } from '../../store/redeem.selectors';
import Image from '../../../../components/Image/Image';

import TangoCardCode from './TangoCardCode';
import TangoCardUrl from './TangoCardUrl';

const styles: { [className: string]: SxProps<Theme> } = {
  name: {
    fontSize: { xs: 24, sm: 32 },
    fontWeight: 'bold',
    color: ({ palette }) => palette.primary.main,
  },
  step: {
    fontSize: 16,
    fontWeight: 'bold',
    color: ({ palette }) => palette.primary.main,
  },
  stepHint: {
    fontSize: 16,
    color: ({ palette }) => palette.primary.main,
  },
};

const TangoCard = (): ReactElement => {
  const product = useSelector(getProduct);

  const { codes, url } = useSelector(getCredentialPartials);
  const isMultiStep = Boolean(codes.length === 1 && url);

  return (
    <Box width="100%" display="flex" alignItems="center" flexDirection="column">
      <Typography sx={styles.name}>{product?.name || ''}</Typography>
      <Box width={['100%', 455]} height={[190, 286]}>
        <Image image={product?.image || ''} backgroundSize="contain" />
      </Box>
      <Box mt={1} pl={[0, 0, 5]} maxWidth="100%" display="flex" flexDirection="column" alignItems="flex-start">
        {codes.map(code => (
          <Box mt={2} mb={1} maxWidth="100%">
            <Box display="flex">
              {isMultiStep && (
                <Box width="70px" flexShrink={0}>
                  <Typography sx={styles.step}>Step 1</Typography>
                </Box>
              )}
              <Typography sx={styles.stepHint}>
                {isMultiStep && `Copy `}
                {code.label}:
              </Typography>
            </Box>
            <Box mt={0.5} ml={[0, isMultiStep ? '70px' : 0]}>
              <TangoCardCode code={code.value} />
            </Box>
          </Box>
        ))}
        {url && (
          <Box mt={2} mb={1} maxWidth="100%">
            <Box display="flex">
              {isMultiStep && (
                <Box width="70px" flexShrink={0}>
                  <Typography sx={styles.step}>Step 2</Typography>
                </Box>
              )}
              <Typography sx={styles.stepHint}>Click URL to open new tab and access landing page:</Typography>
            </Box>
            <Box mt={0.5} ml={[0, isMultiStep ? '70px' : 0]}>
              <TangoCardUrl url={url.value} />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TangoCard;
